module.exports = __webpack_public_path__ + "static/media/Artboard3.76eb116d.jpg";